// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip_tooltip__uxtCb","tooltip-fade-in":"Tooltip_tooltip-fade-in__YASW0","tooltip-fade-out":"Tooltip_tooltip-fade-out__Xkfjt"};